import { useCallback } from "react";
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { usePutRequest } from "src/Utils/Hooks/ApiWrappers/usePutRequest";
import { logger } from "src/Utils/LoggerService/LoggerService";
import { SupportRoles } from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";

/**
 * Promote/demote an Aura Support portal user (Member <-> Admin).
 * Calls PUT /api/v1/aura-support/user/{userId}/role. The backend restricts this to
 * Admins/super admins and rejects self-changes and demoting the last admin.
 */
export const useChangeSupportUserRole = () => {
    const { putRequest, reqestResponse, reqestError, reqestLoading } = usePutRequest();

    const changeRole = useCallback((userId: string, role: SupportRoles) => {
        const baseUrl = Config.GetConfigData().serviceUrl;
        const requestUrl = `${baseUrl}api/v1/aura-support/user/${userId}/role`;
        logger.logInformation(`Request to change Aura Support user ${userId} role to ${role}`);
        putRequest({ role }, requestUrl);
    }, [putRequest]);

    return {
        changeRole,
        changeRoleResponse: reqestResponse,
        changeRoleError: reqestError,
        changeRoleLoading: reqestLoading
    };
};
